import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.handleInput = this.handleInput.bind(this)
    this.element.addEventListener("input", this.handleInput)
    this.element.addEventListener("change", this.handleInput)
  }

  disconnect() {
    this.element.removeEventListener("input", this.handleInput)
    this.element.removeEventListener("change", this.handleInput)
  }

  handleInput() {
    const submitButtons = this.element.querySelectorAll("input[type='submit'], button[type='submit']")
    submitButtons.forEach((button) => {
      if (button.disabled) button.disabled = false
    })
  }
}
